import script from "./ApenzellComponent2.vue?vue&type=script&lang=ts&setup=true"
export * from "./ApenzellComponent2.vue?vue&type=script&lang=ts&setup=true"

import "./ApenzellComponent2.vue?vue&type=style&index=0&id=00f7880a&scoped=true&lang=css"

import exportComponent from "/opt/builds/JFRxnycJ/0/firma/firmenwebseite/website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00f7880a"]])

export default __exports__